/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type Gender = typeof Gender[keyof typeof Gender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  Male: 'Male',
  Female: 'Female',
} as const;
